export const MarkerType = Object.freeze({
  PROPERTY: 'main',
  STATIC: 'static',
  SEARCH_POINT: 'searchpoint'
});

export const LodgeStatus = Object.freeze({
  AVAILABLE: 'available',
  SOLD_OUT: 'sold-out',
  LIMITED: 'limited'
});
